import React from 'react';
import { useTranslation } from 'react-i18next';

const Empty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="empty">
      <i className="empty__img">
        <svg
          id="Layer_1"
          viewBox="0 0 91 91"
          xmlSpace="preserve"
          xmlns="http://www.w3.org/2000/svg">
          <style>{'.st0{fill:#4e7a9e}'}</style>
          <path
            className="st0"
            d="M32 20.3c-2.8 2.5-5.5 5.7-8.5 8-2.7-2.6-9.3-11.6-11.1-8.1-.9 1.8 1 3.9 2 5.2 1.6 2.2 3.3 4.2 5 6.3 1.6 2 3.6 3.7 6.1 2.1 3.9-2.5 7.5-6 11-8.9 3.3-2.6-1.4-7.4-4.5-4.6zM71 20.3c-2.8 2.5-5.5 5.7-8.5 8-2.7-2.6-9.3-11.6-11.1-8.1-.9 1.8 1 3.9 2 5.2 1.6 2.2 3.3 4.2 5 6.3 1.6 2 3.6 3.7 6.1 2.1 3.9-2.5 7.5-6 11-8.9 3.4-2.6-1.3-7.4-4.5-4.6zM66.2 40.4c-.7-3.2-6-2.5-5.7.8 0 .6.1 1.1.2 1.7-1.6 3-2.5 6.7-3.6 9.7-1.4 3.8-2.6 7.6-3.2 11.6-1 6-.6 14.6 7.1 15.5 7.6.9 11.4-7.4 11.3-13.8-.1-4.1-1.4-8.2-2.6-12.1-1.4-4.5-2.5-8.9-3.5-13.4zm.5 28.5c-.6 2.7-2.7 5.8-5.9 5.3-5.7-.9-1.7-13.2-.8-16.3.7-2.3 1.7-4.7 2.5-7.3.9 2.8 2 5.5 3 8.3 1.1 3.2 2 6.7 1.2 10z"
          />
        </svg>
      </i>
      <p className="empty__text">{t('emptyText')}</p>
      <div className="empty__decors">
        <i className="empty__decor empty__decor-first">
          <svg height={91} width={91} xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#FDE497"
              d="M87.912 37.63H56.344L45.512 4.648 34.682 37.63H3.109l25.584 18.21-10.269 31.256 27.088-19.283 27.085 19.283L62.332 55.84z"
            />
            <path
              d="M72.597 89.608a2.504 2.504 0 0 1-1.457-.466L45.512 70.896 19.881 89.143a2.514 2.514 0 0 1-2.947-.023 2.515 2.515 0 0 1-.896-2.808l9.691-29.498L1.652 39.677a2.512 2.512 0 0 1 1.457-4.56h29.753L43.124 3.864a2.514 2.514 0 0 1 4.775 0l10.265 31.253h29.749a2.513 2.513 0 0 1 1.457 4.56L65.297 56.813l9.688 29.498a2.514 2.514 0 0 1-2.388 3.297zM45.512 65.3c.51 0 1.021.155 1.457.466l20.854 14.848-7.878-23.989a2.51 2.51 0 0 1 .93-2.831l19.176-13.65H56.344a2.51 2.51 0 0 1-2.387-1.729l-8.445-25.713-8.443 25.713a2.512 2.512 0 0 1-2.387 1.729H10.973l19.178 13.65a2.514 2.514 0 0 1 .93 2.831L23.2 80.613l20.855-14.847a2.502 2.502 0 0 1 1.457-.466z"
              fill="#454B53"
            />
          </svg>
        </i>
        <i className="empty__decor empty__decor-second">
          <svg height={91} width={91} xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#FDE497"
              d="M87.912 37.63H56.344L45.512 4.648 34.682 37.63H3.109l25.584 18.21-10.269 31.256 27.088-19.283 27.085 19.283L62.332 55.84z"
            />
            <path
              d="M72.597 89.608a2.504 2.504 0 0 1-1.457-.466L45.512 70.896 19.881 89.143a2.514 2.514 0 0 1-2.947-.023 2.515 2.515 0 0 1-.896-2.808l9.691-29.498L1.652 39.677a2.512 2.512 0 0 1 1.457-4.56h29.753L43.124 3.864a2.514 2.514 0 0 1 4.775 0l10.265 31.253h29.749a2.513 2.513 0 0 1 1.457 4.56L65.297 56.813l9.688 29.498a2.514 2.514 0 0 1-2.388 3.297zM45.512 65.3c.51 0 1.021.155 1.457.466l20.854 14.848-7.878-23.989a2.51 2.51 0 0 1 .93-2.831l19.176-13.65H56.344a2.51 2.51 0 0 1-2.387-1.729l-8.445-25.713-8.443 25.713a2.512 2.512 0 0 1-2.387 1.729H10.973l19.178 13.65a2.514 2.514 0 0 1 .93 2.831L23.2 80.613l20.855-14.847a2.502 2.502 0 0 1 1.457-.466z"
              fill="#454B53"
            />
          </svg>
        </i>
        <i className="empty__decor empty__decor-third">
          <svg height={91} width={91} xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#FDE497"
              d="M87.912 37.63H56.344L45.512 4.648 34.682 37.63H3.109l25.584 18.21-10.269 31.256 27.088-19.283 27.085 19.283L62.332 55.84z"
            />
            <path
              d="M72.597 89.608a2.504 2.504 0 0 1-1.457-.466L45.512 70.896 19.881 89.143a2.514 2.514 0 0 1-2.947-.023 2.515 2.515 0 0 1-.896-2.808l9.691-29.498L1.652 39.677a2.512 2.512 0 0 1 1.457-4.56h29.753L43.124 3.864a2.514 2.514 0 0 1 4.775 0l10.265 31.253h29.749a2.513 2.513 0 0 1 1.457 4.56L65.297 56.813l9.688 29.498a2.514 2.514 0 0 1-2.388 3.297zM45.512 65.3c.51 0 1.021.155 1.457.466l20.854 14.848-7.878-23.989a2.51 2.51 0 0 1 .93-2.831l19.176-13.65H56.344a2.51 2.51 0 0 1-2.387-1.729l-8.445-25.713-8.443 25.713a2.512 2.512 0 0 1-2.387 1.729H10.973l19.178 13.65a2.514 2.514 0 0 1 .93 2.831L23.2 80.613l20.855-14.847a2.502 2.502 0 0 1 1.457-.466z"
              fill="#454B53"
            />
          </svg>
        </i>
      </div>
    </section>
  );
};

export default Empty;
